import { useTranslationWithPrefix } from '@hotjar/translations';
import { Text, tokens } from '@hotjar/hotsauce';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import ChurnSurveyIllustration from '../assets/churn-survey-illustration.svg';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ModalHeaderSurvey = (): JSX.Element => {
  const { t } = useTranslationWithPrefix('checkout:churn:surveyv2');

  return (
    <>
      <img src={ChurnSurveyIllustration} alt="churn-survey-illustration" />
      <ContentWrapper>
        <Text as="h1" textType="header4">
          {t('confirmation-modal:heading')}
        </Text>
        <Text
          as="p"
          textType="body2"
          color="text_default"
          css={css`
            margin-top: ${tokens.spacer.x1};
            margin-bottom: 0;
          `}
        >
          {t('intro-text')}
        </Text>
      </ContentWrapper>
    </>
  );
};
